import React, { useRef, useState } from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

export default function GenericFileUploaderPage(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const ref = useRef();
  const { setFileCallBack } = props;
  const [fileName, setFileName] = useState();
  const onFileChange = (event) => {
    setFileName(event.target.files[0].name);
    setFileCallBack(event.target.files[0]);
  };

  return (
    <Paper elevation={0}>
      <Grid container spacing={1} xs={6} className={classes.root}>
        <Grid item xs={2}>
          <input
            className={classes.customInput}
            id="files"
            ref={ref}
            type="file"
            accept=" .xls, .xlsx"
            onChange={onFileChange}
          />
          <Box>
            <Button
              color="secondary"
              variant="contained"
              for="files"
              onClick={() => ref.current?.click()}
            >
              {t('select file')}
            </Button>{' '}
          </Box>
        </Grid>
        <Grid item xs={4}>
          <FormLabel className={classes.titleBlack} hidden={fileName}>
            {t('select to upload')}
          </FormLabel>
          <FormLabel className={classes.titleBlack}>{fileName}</FormLabel>
        </Grid>
      </Grid>
    </Paper>
  );
}
